/** Two-step verification (TOTP) settings (docs/specs/identity.md). */
export const security = {
    title: "Security",
    description: "Protect your account with two-step verification.",
    on: "Two-step verification is on.",
    off: "Two-step verification is off.",
    enable: "Turn on",
    disable: "Turn off",
    password: "Current password",
    continue: "Continue",
    scan: "Scan this QR code with an authenticator app, or enter the setup key by hand.",
    qrAlt: "QR code for your authenticator app",
    secret: "Setup key",
    code: "6-digit code from the app",
    confirm: "Confirm",
    otherDevices: "Turning this on signs you out on your other devices.",
    recoveryTitle: "Save your recovery codes",
    recoveryBody: "Each code works once if you lose your phone. They won't be shown again.",
    copy: "Copy codes",
    copied: "Copied.",
    done: "I've saved them",
    enabled: "Two-step verification is on.",
    disableTitle: "Turn off two-step verification",
    disableBody: "Enter your password and a current code (or a recovery code).",
    disableCode: "Code",
    disabled: "Two-step verification is off.",
    passwordChange: {
        title: "Password",
        body: "Change the password you sign in with. Other devices are signed out.",
        change: "Change password",
        current: "Current password",
        next: "New password",
        hint: "At least 8 characters; not a common password or only digits.",
        save: "Save new password",
        saved: "Password changed.",
        requiredTitle: "Choose your own password",
        requiredBody: "You signed in with a first password from your business. Set your own before you start.",
    },
};
//# sourceMappingURL=security.js.map